<template>
  <div>
    <div class="block lg:hidden mt-1 pb-1 mb-8 border-b">
      <Logo size="sm" />
    </div>
    <h1 class="mb-5 lg:mb-12 lg:border-b lg:pb-6">
      {{ title }}
    </h1>
  </div>
</template>

<script>
import Logo from '@/components/shared/Logo'

export default {
  props: ['title'],
  components: {
    Logo,
  },
}
</script>

<style scoped>
h1 {
  @apply text-3xl;
}
@screen lg {
  h1 {
    font-size: 2.75rem;
  }
}
</style>
